import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioCapsule3 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE3: TIdToPageConfigMap = {
  [PageIdStylioCapsule3.AGE_CAPSULE3]: {
    id: PageIdStylioCapsule3.AGE_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioCapsule3.URGE_CAPSULE3]: {
    id: PageIdStylioCapsule3.URGE_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule3.HAIR_COLOR_CAPSULE3]: {
    id: PageIdStylioCapsule3.HAIR_COLOR_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.EYES_COLOR_CAPSULE3]: {
    id: PageIdStylioCapsule3.EYES_COLOR_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.JEWELRY_CAPSULE3]: {
    id: PageIdStylioCapsule3.JEWELRY_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.BODY_SHAPE_CAPSULE3]: {
    id: PageIdStylioCapsule3.BODY_SHAPE_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.STYLIO_TO_HELP_CAPSULE3]: {
    id: PageIdStylioCapsule3.STYLIO_TO_HELP_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.TALL_CAPSULE3]: {
    id: PageIdStylioCapsule3.TALL_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.WEIGHT_CAPSULE3]: {
    id: PageIdStylioCapsule3.WEIGHT_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.URGE_2_CAPSULE3]: {
    id: PageIdStylioCapsule3.URGE_2_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule3.FEEL_ABOUT_CAPSULE3]: {
    id: PageIdStylioCapsule3.FEEL_ABOUT_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.PERCENTAGE_CAPSULE3]: {
    id: PageIdStylioCapsule3.PERCENTAGE_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.SHOPPING_CAPSULE3]: {
    id: PageIdStylioCapsule3.SHOPPING_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.STYLE_MOST_MATTERS_CAPSULE3]: {
    id: PageIdStylioCapsule3.STYLE_MOST_MATTERS_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.FAVORITE_COLORS_CAPSULE3]: {
    id: PageIdStylioCapsule3.FAVORITE_COLORS_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_CAPSULE3]: {
    id: PageIdStylioCapsule3.LIKE_OR_DISLIKE_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_11_CAPSULE3]: {
    id: PageIdStylioCapsule3.LIKE_OR_DISLIKE_11_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_12_CAPSULE3]: {
    id: PageIdStylioCapsule3.LIKE_OR_DISLIKE_12_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_13_CAPSULE3]: {
    id: PageIdStylioCapsule3.LIKE_OR_DISLIKE_13_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_14_CAPSULE3]: {
    id: PageIdStylioCapsule3.LIKE_OR_DISLIKE_14_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_15_CAPSULE3]: {
    id: PageIdStylioCapsule3.LIKE_OR_DISLIKE_15_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_16_CAPSULE3]: {
    id: PageIdStylioCapsule3.LIKE_OR_DISLIKE_16_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_17_CAPSULE3]: {
    id: PageIdStylioCapsule3.LIKE_OR_DISLIKE_17_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_18_CAPSULE3]: {
    id: PageIdStylioCapsule3.LIKE_OR_DISLIKE_18_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_19_CAPSULE3]: {
    id: PageIdStylioCapsule3.LIKE_OR_DISLIKE_19_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.STYLES_FEEL_LIKE_YOU_CAPSULE3]: {
    id: PageIdStylioCapsule3.STYLES_FEEL_LIKE_YOU_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.URGE_4_CAPSULE3]: {
    id: PageIdStylioCapsule3.URGE_4_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule3.BRAND_CAPSULE3]: {
    id: PageIdStylioCapsule3.BRAND_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.FIND_NEW_CLOTHES_CAPSULE3]: {
    id: PageIdStylioCapsule3.FIND_NEW_CLOTHES_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.NOTHING_TO_WEAR_CAPSULE3]: {
    id: PageIdStylioCapsule3.NOTHING_TO_WEAR_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.OLD_CLOTHES_CAPSULE3]: {
    id: PageIdStylioCapsule3.OLD_CLOTHES_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.COMBINE_CLOTHES_CAPSULE3]: {
    id: PageIdStylioCapsule3.COMBINE_CLOTHES_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.OPTIMIZE_BUDGET_CAPSULE3]: {
    id: PageIdStylioCapsule3.OPTIMIZE_BUDGET_CAPSULE3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule3.URGE_3_CAPSULE3]: {
    id: PageIdStylioCapsule3.URGE_3_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule3.PREPARE_FLOW_CAPSULE3]: {
    id: PageIdStylioCapsule3.PREPARE_FLOW_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule3.EMAIL_CAPSULE3]: {
    id: PageIdStylioCapsule3.EMAIL_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule3.EMAIL_CONSENT_CAPSULE3]: {
    id: PageIdStylioCapsule3.EMAIL_CONSENT_CAPSULE3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule3.SUBSCRIPTIONS_CAPSULE3]: {
    id: PageIdStylioCapsule3.SUBSCRIPTIONS_CAPSULE3,
  },
  [PageIdStylioCapsule3.CANCEL_OFFER_CAPSULE3]: {
    id: PageIdStylioCapsule3.CANCEL_OFFER_CAPSULE3,
  },
  [PageIdStylioCapsule3.SUB_UPSELL_CAPSULE3]: {
    id: PageIdStylioCapsule3.SUB_UPSELL_CAPSULE3,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule3.UPSELL_CAPSULE3]: {
    id: PageIdStylioCapsule3.UPSELL_CAPSULE3,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule3.DOWNLOAD_CAPSULE3]: {
    id: PageIdStylioCapsule3.DOWNLOAD_CAPSULE3,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
